import { demographicConstants } from '../../_constants';
import { demographicDataService } from '../../_services';
import { demographicDataAction } from '../UserProfile/demographicData.action';

export const updateOrDeleteDemographicDataAction = {
    updateOrDeleteDemographicDataHandler
};

function updateOrDeleteDemographicDataHandler(data, id, type) {
    return dispatch => {
        dispatch(request());
        demographicDataService.updateOrDeleteDemographicDataHandler(data, id, type)
            .then(
                demographicData => {
                    dispatch(demographicDataAction.getDemographicDataHandler())
                    dispatch(success(demographicData));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: demographicConstants.REQUEST_UPDATE_DELETE_DEMOGRAPHIC_DATA } }
    function success(demographicData) { return { type: demographicConstants.RECIEVE_UPDATE_DELETE_DEMOGRAPHIC_DATA, demographicData } }
    function failure(error) { return { type: demographicConstants.ERROR_UPDATE_DELETE_DEMOGRAPHIC_DATA, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/demograpicMasters/updateOrDeleteDemographicData.action.js